import { render, staticRenderFns } from "./InputLabelTextDefault.vue?vue&type=template&id=d76a2700&scoped=true&"
import script from "./InputLabelTextDefault.vue?vue&type=script&lang=js&"
export * from "./InputLabelTextDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76a2700",
  null
  
)

export default component.exports